var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.articles.length)?_c('ul',{staticClass:"articles-list"},_vm._l((_vm.articles),function(article){return _c('li',{key:article.id,staticClass:"articles-list-item"},[_c('Article',{attrs:{"article":article,"frontendOrigin":_vm.frontendOrigin}})],1)}),0):_c('Loader')
}
var staticRenderFns = []

export { render, staticRenderFns }